<template>
  <div style="clear: both;">
    <template v-if="readonly">
      <v-text-field
        :model-value="$filters.DateFilter(modelValue)"
        label="Task Review Date"
        variant="underlined"
        prepend-icon="mdi-calendar"
        readonly
        name="taskReviewDate"
      ></v-text-field>
    </template>
    <v-menu
      v-if="!readonly"
      v-model="formSettings.taskReviewDateMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          v-bind="props"
          :model-value="$filters.DateFilter(modelValue)"
          variant="underlined"
          label="Task Review Date"
          prepend-icon="mdi-calendar"
          readonly
          name="taskReviewDate"
        ></v-text-field>
      </template>

      <v-date-picker
        :model-value="selectedDate"
        :hide-header="true"
        :min="formSettings.minStartDate"
        :max="maxDateComputed"
        @update:modelValue="updateValue"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'TaskReviewDate',
  emits: ['update:modelValue'],
  data: () => ({
    formSettings: {
      taskReviewDateMenu: false
    },
    picker: null
  }),
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    readonly: Boolean
  },
  methods: {
    updateValue: function(value) {
      this.formSettings.taskReviewDateMenu = false
      this.$emit('update:modelValue', moment(value).format())
    }
  },
  computed: {
    maxDateComputed: function() {
      var date = new Date()
      date.setDate(date.getDate())
      return date.toISOString()
    },
    selectedDate: function() {
      if (this.modelValue) 
        return new Date(this.modelValue)
      else
        return new Date()
    }
  }
}
</script>

<style scoped></style>
